<template>
  <v-container fluid justify-center>
    <v-row class="contact-header">
      <p class="contact-header__title"
      >
        Contact Me
      </p>
      <p
        class="contact-header__detail"
      >
        Let's discuss some of your ideas and find possible opportunities to work together.
      </p>
      <form
        action="https://formspree.io/f/mdkzggag"
        method="POST"
      >
        <div class="top_fields">
          <label>
            * Name:
            <input type="text" name="name" required>
          </label>
          <label>
            * Email Address:
            <input type="email" name="email" required>
          </label>
        </div>
        <label>
          * Your message:
          <textarea required name="message"></textarea>
        </label>
        <button type="submit">
          Submit
        </button>
      </form>
    </v-row>
  </v-container>  
</template>
    
<script>
export default {
  name: 'contactPage',
  title: 'Darcey Grundy | Contact',
  data: () => ({
  }),
}
</script>
    
<style lang="scss" scoped>
.contact-header {
  padding-top: 20px;
  padding: 15px;
  margin-top: 25px;

  @media (width > 1000px) {
    padding-top: 56px;
    padding: 64px;
    margin-top: 64px;
  }

  &__title {
    letter-spacing: 10%;
    font-weight: 400;
  }

  p {
    margin: 0;
    font-size: 40px;
    font-family: Gasoek One !important;
    color: var(--v-tropicalIndigo-base) !important;

    @media (width > 1000px) {
      font-size: 64px;
    }
  }

  .contact-header__detail {
    font-size: 20px;

    @media (width > 1000px) {
      font-size: 30px;
    }
  }

  form {
    background-color: var(--v-cambridgeBlue-base) !important;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    padding: 20px;
    width: 95%;
    margin: auto;
    margin-top: 50px;

    @media (width > 1000px) {
      width: 80%;
    }

    label {
      margin: auto;
      display: flex;
      flex-direction: column;
      width: 100%;
      color: #fff;
    }

    input, textarea {
      border-bottom: 1px solid #fff;
      margin-bottom: 5px;
      color: #fff;  
    }

    input:focus, textarea:focus {
      border: none;
      background-color: var(--v-cambridgeBlue-base) !important;
    }

    button {
      border-radius: 25px;
      margin: 0 auto;
      margin-top: 25px;
      padding: 12px 22px;
      font-size: 28px;
      font-family: Bebas Neue;
      color: #fff;
      background-color: var(--v-flame-base) !important;
    }
  }
}
</style>